import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import DataTable from '../../components/Table/DataTable';

import { showAlert } from '../../store/ducks/alert';
import { CircularProgress } from '@material-ui/core';
import { Clear } from '@material-ui/icons';

import { getListOfDuplicated, updateTransactionStatus, updateTransactionConfirmedStatus } from '../../services/payment';

const DuplicatedTransactionsList = () => {
  const dispatch = useDispatch();
  const params = useParams();

  const [duplicatedTransactions, setDuplicatedTransactions] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    displayDuplicatedTransactions();
  }, []);

  const displayDuplicatedTransactions = async () => {
    try {
      setIsLoading(true);
      const { data } = await getListOfDuplicated(params.transactionIdInOrigin, params.paymentToken);
      if (data.length) {
        setDuplicatedTransactions(data);
        setTotalItems(data.length);
      } else {
        setDuplicatedTransactions([]);
        setTotalItems(0);
      }
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
      console.log(error);
    }
  };

  const headers = ['paymentToken', 'toChannelId', 'value', 'paymentType', 'status', 'confirmed', 'paymentDate'];
  const customActions = [
    {
      action: async row => {
        await updateTransactionStatus(row.uid, 'canceled');
        await updateTransactionConfirmedStatus(row.uid, false);
      },
      icon: <Clear />,
    },
  ];

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>Duplicated Transactions List({totalItems})</h1>
      </div>

      <DataTable
        useUid
        head={headers}
        body={duplicatedTransactions}
        bodyColumn={headers}
        linkPath="transactions"
        customActions={customActions}
        isNotOrdenable
      />
    </>
  );
};

export default DuplicatedTransactionsList;
